import * as ErrorLogsActions from './error-logs.actions';

export default ErrorLogsActions;
